module.exports = __webpack_public_path__ + "img/7heuvelen-logo.155898b0.png";